import React from 'react';
import styled, {css} from 'styled-components';

import logoImgOriginal from './logo_bomsystems_original.png';
import logoImg from './logo_only_bomsystems.png';
import logoTextImg from './logo_text_bomsystems.png';

const LOGO_IMG_FULL = styled.img`    
  position: static;
  top: 0;
  left: 0;
  height: ${props => props.H && props.H};
`;
const LOGO_IMG = styled.img`    
  position: static;
  top: 0;
  left: 0;
  height: ${props => props.H && props.H};
  @media (max-width: 1024px) {
    margin-top: 4px;
    height: 32px;
  }
  @media (max-width: 424px) {
    margin-top: 4px;
    height: 24px;
  }
`;
const LOGO_TEXT_IMG = styled.img`
  position: static;
  top: 0;
  left: 0;
  height: ${props => props.H && props.H};
  margin-left: ${props => props.SEP && props.SEP};
  @media (max-width: 1024px) {
    margin-top: 4px;
    height: 32px;
  }
  @media (max-width: 424px) {
    margin-top: 4px;
    height: 24px;
  }
`;

function Logo(props) {
  let H = '40px'; /* 로고 이미지의 크기는 높이 40px 로 정함 */
  let SEP = '17px'; /* 로고 이미지의 크기가 높이 40px 일 때 '로고 이미지'와 '로고 텍스트 이미지' 사이의 간격을 17px 로 정함 */
  return (
    <div className="Logo">
        {/*
        <LOGO_IMG_FULL H={H} src={logoImgOriginal} />
        */}
        <LOGO_IMG H={H} src={logoImg} />
        <LOGO_TEXT_IMG H={H} SEP={SEP} src={logoTextImg} />
    </div>
  );
}

export default Logo;
